import type { IconProps } from './base';
import { BaseIcon } from './base';

export function IconAttributeJourney(props: IconProps) {
  return (
    <BaseIcon {...props}>
      <path
        d="M4 8C4.55228 8 5 7.55229 5 7V5H7C7.55228 5 8 4.55228 8 4C8 3.44772 7.55228 3 7 3H4C3.44772 3 3 3.44772 3 4V7C3 7.55229 3.44772 8 4 8Z"
        fill="currentColor"
      />
      <path
        d="M4 16C3.44772 16 3 16.4477 3 17V20C3 20.5523 3.44772 21 4 21H7C7.55229 21 8 20.5523 8 20C8 19.4477 7.55229 19 7 19H5V17C5 16.4477 4.55228 16 4 16Z"
        fill="currentColor"
      />
      <path
        d="M17 5C16.4477 5 16 4.55228 16 4C16 3.44772 16.4477 3 17 3H20C20.5523 3 21 3.44772 21 4V7C21 7.55228 20.5523 8 20 8C19.4477 8 19 7.55228 19 7V5H17Z"
        fill="currentColor"
      />
      <path
        d="M20 16C19.4477 16 19 16.4477 19 17V19H17C16.4477 19 16 19.4477 16 20C16 20.5523 16.4477 21 17 21H20C20.5523 21 21 20.5523 21 20V17C21 16.4477 20.5523 16 20 16Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.6342 14.0976L7.53652 16.9513C7.37391 17.0326 7.2318 17.0121 7.11017 16.8898C6.98789 16.7682 6.9674 16.6261 7.0487 16.4635L9.90241 10.3658C9.95119 10.2683 10.0162 10.1788 10.0975 10.0975C10.1788 10.0162 10.2683 9.95119 10.3658 9.90241L16.4635 7.0487C16.6261 6.9674 16.7682 6.98789 16.8898 7.11017C17.0121 7.2318 17.0326 7.37391 16.9513 7.53652L14.0976 13.6342C14.0488 13.7317 13.9838 13.8212 13.9025 13.9025C13.8212 13.9838 13.7317 14.0488 13.6342 14.0976ZM11.3054 12.6946C11.492 12.882 11.7236 12.9756 12 12.9756C12.2764 12.9756 12.5083 12.882 12.6956 12.6946C12.8823 12.508 12.9756 12.2764 12.9756 12C12.9756 11.7236 12.8823 11.4917 12.6956 11.3044C12.5083 11.1177 12.2764 11.0244 12 11.0244C11.7236 11.0244 11.492 11.1177 11.3054 11.3044C11.118 11.4917 11.0244 11.7236 11.0244 12C11.0244 12.2764 11.118 12.508 11.3054 12.6946Z"
        fill="currentColor"
      />
    </BaseIcon>
  );
}
